import React, { useEffect } from 'react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[10000] bg-black/70 flex items-center justify-center p-5" onClick={onClose} data-id="element-144">
      <div className="bg-[#FAF7F2] rounded-2xl p-10 max-w-[700px] w-full max-h-[85vh] overflow-y-auto relative" onClick={e => e.stopPropagation()} data-id="element-145">
        <button onClick={onClose} className="absolute top-4 right-5 text-2xl text-[#6B4C3B] bg-transparent border-none cursor-pointer hover:text-[#3D2B1F]" data-id="element-146">
          ×
        </button>

        <h2 className="text-2xl text-[#3D2B1F] mb-5" data-id="element-147">{title}</h2>

        <div className="text-sm text-[#6B4C3B] font-sans leading-relaxed" data-id="element-148">
          {children}
        </div>
      </div>
    </div>;
}